import React, { PropsWithChildren } from "react";
import { _goToBack } from "router/helper";

import {
  View,
  StyleSheet,
  StatusBar as RNStatusBar,
  SafeAreaView,
  TouchableOpacity,
} from "react-native";
import { Button, Img, ScrollLayout, Text } from "component";
import { StatusBar } from "expo-status-bar";

import { colors, sizes, strings } from "asset/constant";
import { logo } from "asset/logo";
import { css } from "style";
import tinycolor from "tinycolor2";

type ITemplate = {
  hideBackButton?: boolean;
  submit?: () => void;
  submitLabel?: string;
  submitLoading?: boolean;
  showHelper?: boolean;
};
export default function EntryScreensForm(props: PropsWithChildren<ITemplate>) {
  const { submit, submitLabel, submitLoading, hideBackButton } = props;

  return (
    <>
      <StatusBar backgroundColor={colors.bg.screen} style="dark" />

      <ScrollLayout contentContainerStyle={styles.scrollContainer}>
        <View style={{ height: RNStatusBar.currentHeight }} />

        <View style={{ ...css.fitWidth, ...css.centralElements }}>
          <View style={styles.logoContainer}>
            <Img
              resizeMode="contain"
              style={styles.logo}
              source={logo.entries_screens}
            />
          </View>
        </View>
        <View style={styles.inputsSection}>
          {props.children}

          <Button
            onPress={submit}
            loading={submitLoading}
            title={{ value: submitLabel }}
            style={{ marginVertical: 2 * sizes.space }}
          />
        </View>

        <View style={{ alignSelf: "center", top: -10 }}>
          <Text size={"xl"} weight="extraBold" color={colors.text.muted + "88"}>
            {strings._app}
          </Text>
        </View>

        {hideBackButton ? null : (
          <Button
            onPress={_goToBack}
            square={45}
            bgColor={colors.transparent}
            absolute={{ zIndex: 10, top: 30, left: 10 }}
            icon={{
              size: 18,
              name: "left",
              color: colors.text.dark,
            }}
          />
        )}
      </ScrollLayout>
    </>
  );
}

const styles = StyleSheet.create({
  scrollContainer: { alignItems: "center", backgroundColor: colors.bg.screen },

  logoContainer: {
    width: "80%",
    maxWidth: 340,
    aspectRatio: 3.16,
    alignSelf: "center",
    marginTop: 50,
  },

  logo: {
    width: "100%",
    height: "100%",
  },

  inputsSection: {
    maxWidth: 400,
    ...css.fitWidth,
    ...css.paddingH,
    ...css.container,
    justifyContent: "center",
  },

  supportPhone: { textDecorationLine: "underline" },
});
